export const DocumentCheck = (props) => (
  <svg width="33px" height="42px" viewBox="0 0 33 42" {...props}>
    <g
      id="Features"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="feature---CSP" transform="translate(-499.000000, -1932.000000)">
        <g id="Group-34" transform="translate(240.000000, 1646.000000)">
          <g id="Group-27" transform="translate(0.000000, 121.000000)">
            <g id="Group-26" transform="translate(260.000000, 166.000000)">
              <g id="1-right">
                <path
                  d="M29.8088889,7.58666667 L23.5244444,1.30222222 C22.6911111,0.468888889 21.56,0 20.3822222,0 L4.44444444,0 C1.98888889,0 2.66453526e-15,1.98888889 2.66453526e-15,4.44444444 L2.66453526e-15,35.5555556 C2.66453526e-15,38.0111111 1.98888889,40 4.44444444,40 L26.6666667,40 C29.1222222,40 31.1111111,38.0111111 31.1111111,35.5555556 L31.1111111,10.7288889 C31.1111111,9.55111111 30.6422222,8.42 29.8088889,7.58666667 L29.8088889,7.58666667 Z"
                  id="Path"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
                <g id="interface-essential-112" transform="translate(4.000000, 11.000000)">
                  <polygon id="Path" points="0 0 24 0 24 24 0 24" />
                  <polyline
                    id="Path"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    points="18.5 7.5 9.5 16.5 5.5 12.5"
                  />
                </g>
                <path
                  d="M31.1111111,11.1111111 L22.2222222,11.1111111 C20.9955556,11.1111111 20,10.1155556 20,8.88888889 L20,0"
                  id="Path"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
